<template>
  <div class="bullet-proofs-init-wrapper">
    <el-form
      ref="formDate"
      :model="formDate"
      :rules="editRules"
      :label-width="`${adaptationVars.formLabelWidth}px`"
      class="demo-ruleForm"
      label-position="left"
    >
      <el-form-item v-if="formDate.data" label="随机因子" prop="path">
        <el-input v-model="formDate.data" disabled></el-input>
      </el-form-item>
    </el-form>
    <el-button type="primary" @click="handleInit()">生成随机因子</el-button>
  </div>
</template>

<script>
import adaptation from '@/mixins/adaptation'
export default {
  name: 'Index',
  mixins: [adaptation],
  adaptationVarsDefine: {
    formLabelWidth: 100
  },
  data() {
    let validateLevel = (rule, value, callback) => {
      if (value > 5) {
        callback(new Error('Level不能大于5'))
      } else {
        callback()
      }
    }
    return {
      formDate: {
        data: ''
      },
      orgOtion: [],
      editRules: {
        level: [{ required: true, message: '请输入', trigger: 'blur', validator: validateLevel }]
      },
      adaptationVars: {
        formLabelWidth: 100
      }
    }
  },
  mounted() {},
  methods: {
    handleInit() {
      this.$refs.formDate.validate(valid => {
        if (valid) {
          this.$apis.bulletproofs.genOpening().then(res => {
            if (res) {
              this.formDate.data = res.data
              localStorage.setItem('opening', res.data)
              this.$message.success('生成成功!')
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
</style>
